import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import ModalContext, { IModalContext, IModalContextState } from './modal-context';

const ModalProvider: React.FC<{ children: React.ReactNode }> = (props) => {
  const location = useLocation();

  const [state, setState] = useState<IModalContextState>(() => ({
    component: null,
  }));
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const showModal = useCallback<IModalContext['showModal']>((component, props) => setState({ component, props }), []);

  const hideModal = useCallback<IModalContext['hideModal']>(() => setState({ component: null }), []);

  const context = useMemo<IModalContext>(
    () => ({ ...state, showModal, hideModal, open, handleOpen, handleClose }),
    [state, showModal, hideModal, open, handleOpen, handleClose],
  );

  useEffect(() => {
    hideModal();
  }, [location, hideModal]);

  const { component: Component, props: componentProps } = state;

  return (
    <ModalContext.Provider value={context}>
      {props.children}

      {Component ? <Component close={hideModal} {...componentProps} /> : null}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
